module.exports = __webpack_public_path__ + "img/Balkonmittreppe.f926a741.webp";